import { Button } from 'antd'
import Colors from '../../utils/colors'

export const CustomButton = ({ children, style, classNames, ...props }) => {
  const defaultStyle = {
    width: '100%',
    height: 45,
    borderRadius: 8,
    backgroundColor: Colors.primary,
    borderColor: Colors.primary,
    fontWeight: 600
  }

  return (
    <Button 
      type="primary"
      className={classNames || ''}
      style={{ ...defaultStyle, ...style }}
      {...props}
    >
      {children}
    </Button>
  )
}